export default function Viewmodel$capture () {
	this.captureGroups.push([]);
}
